export default __webpack_public_path__ + "static/media/loading.2c5dfacb.gif";